import React, {useState} from 'react'
import {useTranslation} from "react-i18next";
import {Link} from 'react-router-dom';
import DateFormated from "../Utils/Date/Date";
import SimpleGauge from "../UI/SimpleGauge"
import Currency from "../Utils/Number/Currency";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

const cardSummaryPayment = (props) => {

    const {t, i18n} = useTranslation();
    let account = props.account;
    let percent = props.percent;
    let amount = props.amount;
   // let intransit = props.intransit;
    let total = props.total;

    return <div className="cardsummary cardsummary--payment">
        <div className="cardsummary__content">
            <div className="d-flex flex-wrap">
                <div className="col-md-12 col-lg-6">
                    <div className="cardsummary__content__box d-flex flex-column flex-sm-row justify-content-between">
                        <div>
                            <h2 className="headline headline--section headline--margin--20">
                                {t("account.summary.details.title")}</h2>
                            <strong>
                                {(account.address.addressLine1) &&
                                <span>{account.address.addressLine1}<br/></span>}
                                {(account.address.addressLine2) &&
                                <span>{account.address.addressLine2}<br/></span>}
                                {(account.address.city) &&
                                <span>{account.address.city}, {account.address.stateOrProvinceCode}<br/></span>}
                                {account.address.postalCode}
                            </strong>
                            <div className="mt-3">
                                {t("account.summary.details.number")}<br/>
                                <strong>{account.accountCode}</strong>
                            </div>
                        </div>
                        <div>
                            <div className="cardsummary__content__box-spacer"></div>
                            {account.lastStatementDate !== null && <div>
                                {t("account.summary.details.laststatement")}<br/>
                                <strong><DateFormated date={account.lastStatementDate} withTime={false}/>
                                    &nbsp;&nbsp;&nbsp;&nbsp;{/*<Currency value={999}/>*/}</strong>
                            </div>}
                        </div>
                    </div>
                </div>

                <div className="col-md-12 offset-lg-1 col-lg-5">
                    <div className="cardsummary__content__box d-flex flex-column align-items-center">
                        <SimpleGauge
                            percent={percent.toString()}
                            color="#55B545"
                            //intervals={[60,85,101]}
                            //colors={['green','rgba(255,255,40,.8)','#d73a49']}
                        >
                            <div>{t("account.summary.details.totaltopay")}
                                <br/>
                                <span className="price">
                                    <Currency value={amount}/>
                                </span>
                            </div>
                        </SimpleGauge>
                        <div className="text-center mt-2">
                            {/*t("account.summary.details.intransit")} : <strong><Currency value={intransit}/></strong>*/}
                            <br/>
                            {t("account.summary.details.amounttotaldue")} : <strong><Currency value={total}/></strong>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
};


export default cardSummaryPayment
